const AWARD_TYPE_MAP = {
  BADGE: 'badge',
  CERTIFICATION: 'certification',
  ACCREDITATION: 'accreditation'
};
export function toAwardType(credentialType) {
  var _AWARD_TYPE_MAP$crede;
  if (!credentialType) return 'certification';
  return (_AWARD_TYPE_MAP$crede = AWARD_TYPE_MAP[credentialType]) !== null && _AWARD_TYPE_MAP$crede !== void 0 ? _AWARD_TYPE_MAP$crede : 'certification';
}
export function cleanTrackingProps(props) {
  return Object.fromEntries(Object.entries(props).filter(([, v]) => v != null));
}